import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import type {
	FieldDiaryEntryDTO,
	FieldDiaryRequestOptions,
	UpdateFieldDiaryNotePayload,
} from './types';

export const useUpdateFieldDiaryNote = ({
	forBinding: ownerForBinding,
}: FieldDiaryRequestOptions = {}) => {
	const queryClient = useQueryClient();
	const contextForBinding = useForBindingId();
	const forBinding = ownerForBinding ?? contextForBinding;

	return useMutation({
		mutationFn: async ({ id, data }: { id: string; data: UpdateFieldDiaryNotePayload }) => {
			try {
				return (
					await api.put<{ data: FieldDiaryEntryDTO }>(`/field-diary/notes/update/${id}`, data, {
						params: { forBinding },
					})
				).data.data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar nota do diário de campo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['fieldDiary'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao atualizar nota do diário de campo:',
				getApiErrorMessage(error, 'Erro ao atualizar nota do diário de campo')
			),
	});
};
